import React from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '1rem',
    margin: '20px auto'
  },
  question: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginLeft: 10,
      fontSize: 21,
      fontWeight: 'bold'
    }
  },
  answer: {
    display: 'flex',
    alignItems: 'baseline',
    '& p': {
      marginLeft: 10,
      fontSize: 19
    }
  }
}));

const QuestRespContainer = ({ question, answer }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.container}>
      <div className={classes.question}>
        <h2>Q:</h2>
        <p>{question}</p>
      </div>
      <div className={classes.answer}>
        <h2>A:</h2>
        <p>{answer}</p>
      </div>
    </Paper>
  );
};

export default QuestRespContainer;
